export default __webpack_public_path__ + "static/MilanLogoDesktop-17b20f2e799298fe4472cba58287a973.svg";